import React from "react";
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, DumbbellIcon, BoxIcon } from "lucide-react";
const stats: Array<[BoxIcon, string, string]> = [[BookOpenCheckIcon, '350+', 'Pages of coaching material'], [ClipboardListIcon, '60+', 'Ready-to-coach sessions'], [DumbbellIcon, '150+', 'Detailed exercises'], [CalendarDaysIcon, '6', 'Complete volumes']];
const tags = ['Bodyweight foundations', 'Kettlebells', 'Bands & med balls', 'Clinical protocols', 'Pre-natal & seniors', 'Beginner · Intermediate · Pro'];
export function SystemSection() {
  return <section className="bg-stone-100 px-5 py-20" data-id="element-187" data-mp="2sseyf9b5x2vk">
      <div className="mx-auto max-w-6xl text-center" data-id="element-188" data-mp="2st6v6nghx6nf">
        <p className="inline-block border border-line bg-white px-4 py-2 text-[11px] font-semibold uppercase tracking-[.2em] text-sage-700" data-id="element-189" data-mp="2ntao2fci4z3n">
          The system architecture
        </p>
        <h2 className="mt-7 font-display text-[2.75rem] font-semibold uppercase leading-[.95] tracking-[.02em] text-ink-900 sm:text-6xl" data-id="element-190" data-mp="2iw26afv9mx2x">
          Functional
          <span className="block font-medium normal-case italic tracking-normal text-clay-500" data-id="element-191" data-mp="13yg527i6953v">
            Ready
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink-600" data-id="element-192" data-mp="u11yr0pypwpa">
          Over 350 pages of session plans, professional exercise libraries,
          coaching cues and clinical guidance —{' '}
          <strong className="font-semibold text-ink-900" data-id="element-193" data-mp="1mpz6i9wjsb3s">
            all done for you.
          </strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-194" data-mp="1rp279i5hvv5y">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-line bg-white p-7" data-id="element-195" data-mp="1cqi2dwwy259x">
              <Icon className="mx-auto h-6 w-6 text-sage-600" data-id="element-196" data-mp="1hq3aawu3dnys" />
              <p className="mt-4 font-display text-4xl font-semibold text-ink-900" data-id="element-197" data-mp="1hspf4opllpdb">
                {value}
              </p>
              <p className="mx-auto mt-1 max-w-[16ch] text-[11px] font-medium uppercase tracking-[.14em] text-ink-600" data-id="element-198" data-mp="6b7o8pt48k87">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-3 border border-line bg-white p-8" data-id="element-199" data-mp="23z1rv593yqxm">
          <p className="text-[11px] font-semibold uppercase tracking-[.2em] text-ink-900" data-id="element-200" data-mp="23ztkc77es8jo">
            Full coverage for every session and every client
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-201" data-mp="1u871ppsqr76w">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-line bg-stone-50 px-3 py-2 text-xs font-medium text-ink-800" data-id="element-202" data-mp="1panfa2lw3o3v">
                <CheckIcon className="h-3.5 w-3.5 text-sage-600" data-id="element-203" data-mp="1l78u6xj3ghjk" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}